import { render } from "./Mallki.vue?vue&type=template&id=b6e2ff70&scoped=true"
import script from "./Mallki.vue?vue&type=script&lang=ts"
export * from "./Mallki.vue?vue&type=script&lang=ts"

import "./Mallki.vue?vue&type=style&index=0&id=b6e2ff70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b6e2ff70"

export default script